import React, { useCallback, useContext, useEffect, useState } from "react";
import { ExploreBase } from "../../components/ExploreBase/ExploreBase";
import { useQueryTransactions } from "../../hooks/useQueryTransactions";
import { styles } from "./styles";
import { isMobile } from "react-device-detect";
import { MusicNFT } from "../../components/ExploreBase/types";
import { getPublishedTrack } from "../../services/trackService";
import { RpcError } from "grpc-web";
import { GetPublishedTracksResponse } from "../../proto/api_pb";
import { GetTrackResponse } from "../../proto/api_pb";
import { FractionalTransactionState } from "../../proto/api_pb";
import { Box, Button } from "@mui/material";
import useGetValidAccessToken from "../../hooks/useGetValidAccessToken";
import { UserDetailsContext } from "../../contexts";
import { TEXT_COLOR } from "../../theme";

const Explore: React.FC = () => {
  const { musicNFTs, isTransactionsLoading } = useQueryTransactions();
  const [publicTracks, setPublicTracks] = useState<Array<MusicNFT>>([]);
  const [selectedPanel, setSelectedPanel] = useState("Tracks");
  const [loading, setLoading] = useState(false);
  const { getValidAccessToken } = useGetValidAccessToken();
  const { allUsers } = useContext(UserDetailsContext);

  const handleGetPublishedTracksResponse = async (
    response: GetPublishedTracksResponse
  ) => {
    const res: GetTrackResponse[] = response.getTracksList();
    const trackNfts: any = [];
    res.forEach((el) => {
      const title = el?.getTrack()?.getTitle();
      const artist = el?.getTrack()?.getArtist();
      const description = el?.getTrack()?.getDescription();
      const image = el?.getTrack()?.getImageUrl();
      const genres = el?.getTrack()?.getSongMetadata()?.getGenre();
      const timestamp = el?.getTrack()?.getTimestamp();
      const contributors = el?.getTrack()?.getCollaboratorsList();
      const state = FractionalTransactionState.TRANSACTION_MINTED;
      const ownerId = el?.getTrack()?.getOwnerId();
      const id = el.getTrack()?.getId();
      const price = "0";
      const txnId = el?.getTrack()?.getId();
      const song = el?.getTrackVersion()?.getTrackUrl();
      trackNfts.push({
        txnId,
        id,
        title,
        artist,
        description,
        image,
        song,
        price,
        genres,
        timestamp,
        contributors,
        ownerId,
        state,
      });
    });
    return trackNfts;
  };

  const getPublishedTracks = useCallback(async () => {
    setLoading(true);
    try {
      const accessToken = await getValidAccessToken();
      const response = await getPublishedTrack(accessToken, allUsers);
      if (response instanceof RpcError) {
        throw response;
      }
      if (response instanceof GetPublishedTracksResponse) {
        const publishedTrack = await handleGetPublishedTracksResponse(response);
        setPublicTracks(publishedTrack);
        setLoading(false);
      }
    } catch (er) {
      console.log(er);
    }
  }, [getValidAccessToken, allUsers]);

  useEffect(() => {
    document.title = "OmMuse";
    if (allUsers) getPublishedTracks();
  }, [getPublishedTracks, allUsers]);

  return (
    <>
      <div style={styles.container}>
        <h1 style={styles.pageDescription}>
          Explore Music From the {isMobile && <br />} OmMuse Community
        </h1>
      </div>
      <Box sx={styles.sectionButtonsContainer}>
        <Button
          sx={
            selectedPanel === "Tracks"
              ? styles.pageTitlesActive
              : { ...styles.pageTitlesDeactive, ...{ color: TEXT_COLOR } }
          }
          onClick={() => setSelectedPanel("Tracks")}
        >
          Tracks
        </Button>
        <Button
          sx={
            selectedPanel === "NFT"
              ? styles.pageTitlesActive
              : { ...styles.pageTitlesDeactive, ...{ color: TEXT_COLOR } }
          }
          onClick={() => setSelectedPanel("NFT")}
        >
          NFTs
        </Button>
      </Box>
      {selectedPanel === "NFT" && (
        <ExploreBase
          musicNFTs={musicNFTs}
          isLoading={isTransactionsLoading}
          isTrack={false}
        />
      )}
      {selectedPanel === "Tracks" && (
        <ExploreBase
          musicNFTs={publicTracks}
          isLoading={loading}
          isTrack={true}
        />
      )}
    </>
  );
};

export default Explore;
